import styles from './TableSection.scss?inline';

import {BaseContainer} from "../../base/customComponent/BaseContainer";

class NXTTableSection extends BaseContainer {
    constructor() {
        super();
        this.customStyle = styles;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            `table-section`,
        );
        container.innerHTML = `
            <header></header>
            <div class="base-grid">
                <div>
                    <slot></slot>
                </div>
                <div class="cta">
                    <slot name="cta"></slot>
                </div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        container.querySelector('header').append(this.createHeader('horizontal'));
        return container;
    }

}

customElements.define('nxt-table-section', NXTTableSection);
